<sdps-spinner type="loading" show-by-default="false" id="module-spinner" class="hydrated aip-custom-loading-spinner">
  <div class="sdps-sr-only" aria-live="polite">Loading</div>
  <div tabindex="0" class="sdps-spinner-container sdps-spinner-container--module" style="display: block">
    <div class="sdps-spinner sdps-flex-center">
      <span aria-hidden="true" class="sch sch-spinner sch-spin-stepped"></span>
    </div>
  </div>
</sdps-spinner>
